import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { API_URL, securityHeaders } from "../Constants";

//post an email
const addEmail = (values) => {
  return axios.post(API_URL + `/api/Notifications/PostNotifications`, values, {
    headers: securityHeaders,
  });
};

export const useAddNotification = () => {
  return useMutation(addEmail);
};

//get an email
const fetchNotifications = async () => {
  return await axios.get(API_URL + "/api/Notifications/Notifications", {
    headers: securityHeaders,
  });
};
export const useFetchNotifications = () => {
  return useQuery({
    queryKey: ["notifications"],
    queryFn: () => fetchNotifications(),
    enabled: true,
  });
};

///delete email
const deleteEmail = (notificationId) => {
  return axios.delete(
    API_URL + `/api/Notifications/Notifications/${notificationId}`,
    {
      headers: securityHeaders,
    }
  );
};

export const useDeleteEmail = () => {
  return useMutation(deleteEmail);
};

//send email to applicants
const sendEmail = (values) => {
  return axios.post(API_URL + `/api/Notifications/SendNotification`, values, {
    headers: securityHeaders,
  });
};

export const useSendEmail = () => {
  return useMutation(sendEmail);
};

//send email to interested
const sendEmailInterested = (values) => {
  return axios.post(
    API_URL + `/api/Notifications/SendShowingInterestNotification`,
    values,
    {
      headers: securityHeaders,
    }
  );
};

export const useSendEmailInterested = () => {
  return useMutation(sendEmailInterested);
};

///get email types

const fetchEmailTypes = async () => {
  return await axios.get(API_URL + "/api/Notifications/NotificationsTypes", {
    headers: securityHeaders,
  });
};
export const useFetchEmailTypes = () => {
  return useQuery({
    queryKey: ["emailTypes"],
    queryFn: () => fetchEmailTypes(),
    enabled: true,
  });
};

//change notification status

const changeEmailStatus = async (values) => {
  return await axios.post(
    API_URL +
      `/api/Notifications/ChangeNoticationStatus?NotificationId=${values.NotificationId}&isActive=${values.isActive}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

export const useChangeEmailStatus = () => {
  return useMutation(changeEmailStatus);
};
